// Swiperインスタンスを管理する変数
let carSlideSwiper = null;

// Swiperライブラリと要素が確実に利用可能になってから初期化
function initCarSlideSwiper() {
  // 既存のインスタンスがあれば破棄
  if (carSlideSwiper) {
    carSlideSwiper.destroy(true, true);
    carSlideSwiper = null;
  }

  // Swiperライブラリが読み込まれているか確認
  if (typeof Swiper === 'undefined') {
    setTimeout(initCarSlideSwiper, 50);
    return;
  }

  // 対象要素が存在するか確認
  const swiperElement = document.querySelector('.car-slide-swiper');
  if (!swiperElement) {
    setTimeout(initCarSlideSwiper, 50);
    return;
  }

  // 車種ラインナップ用Swiperの初期化
  carSlideSwiper = new Swiper('.car-slide-swiper', {
    // 基本設定（小画面デフォルト）
    slidesPerView: 4,
    spaceBetween: 8,
    loop: true,

    // 自動再生（Autoplayモジュールを使用）
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
      stopOnLastSlide: false,
    },

    // ナビゲーションボタン
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
    },

    // ナビゲーションの自動非表示を無効化
    watchOverflow: false,

    // レスポンシブ設定
    breakpoints: {
      320: {
        slidesPerView: 4,
        spaceBetween: 8,
      },
      480: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    },

    // 初期化完了時のコールバック
    on: {
      init: function() {
      },
    },
  });
}

// DOMContentLoadedイベントで初期化
document.addEventListener('DOMContentLoaded', initCarSlideSwiper);
